
import React from 'react';
import { Button } from '../../../components/base/Button';
import { useNavigate } from 'react-router-dom';

export const HeroSection: React.FC = () => {
  const navigate = useNavigate();

  const handleExplore = () => {
    navigate('/group-tours');
  };
  return (
    <section
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('/images/cruises-hero.jpg')`
      }}
    >
      <div className="w-full max-w-4xl mx-auto px-6 text-center">
        <div className="bg-white/95 backdrop-blur-sm rounded-lg p-8 md:p-12 shadow-2xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            Luxury Cruises With PrimeMeridian
          </h1>
          <p className="text-lg md:text-xl text-gray-700 mb-8 leading-relaxed max-w-3xl mx-auto">
            Discover the most extraordinary luxury vacations at sea with your choice of unique cruises, each of which reveal the world's most inspiring destinations from a rewarding new perspective. Travel to the shores of all seven continents of luxury expeditions.
          </p>
          <Button size="lg" onClick={handleExplore} className="px-8 py-4 text-lg">
            <i className="ri-compass-3-line w-5 h-5 flex items-center justify-center mr-2"></i>
            Explore
          </Button>
        </div>
      </div>
    </section>
  );
};
